import './FormColumn.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class FormColumn extends React.Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        return (
            <div className={`c-form-column ${this.props.className || ''}`}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormColumn/index.js